module.exports = __webpack_public_path__ + "img/UTFRON-5.f8677172.jpg";